
class SVG3DTagCloud {



constructor( element, params ) {

        this.entryHolder = [];
        this.tooltip;

        this.radius;
        this.diameter;

        this.mouseReact = true;
        this.mousePos = { x: 0, y: 0 };

        this.center2D;
        this.center3D = { x: 0, y: 0, z: 0 };

        this.speed = { x: 0, y: 0 };

        this.position = { sx: 0, cx: 0, sy: 0, cy: 0 };

        this.MATHPI180 = Math.PI / 180;

        this.svg;
        this.svgNS = 'http://www.w3.org/2000/svg';

        this.bg;
        console.log(element);
        let element1 = document.getElementById("skills");
this.element = element;
//this.params = params;
this.settings =[];
for ( var prop in params )
    this.settings[ prop ] = params[ prop ];
        //---

        
        this.init();

}//constructor ends

init() {

            this.svg = document.createElementNS( this.svgNS, 'svg' );
            console.log(this.svg);

            this.svg.addEventListener( 'mousemove', ( event ) => {

            var rect = this.svg.getBoundingClientRect();

            this.mousePos = { 
                x: event.clientX - rect.left, 
                y: event.clientY - rect.top 
                }

            });

            this.element.appendChild( this.svg );

            if ( this.settings.bgDraw ) {
        
                this.bg = document.createElementNS( this.svgNS, 'rect' );
                this.bg.setAttribute( 'x', 0 );
                this.bg.setAttribute( 'y', 0 );
                this.bg.setAttribute( 'fill', this.settings.bgColor );

                this.svg.appendChild( this.bg );

            }

            //---
            
            this.addEntries();
            this.reInit();
            this.animloop();

            //---

            window.addEventListener( 'resize', this.resizeHandler );

        };

         reInit() {

            var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

            var svgWidth = windowWidth;
            var svgHeight = windowHeight;

            if ( this.settings.width.toString().indexOf( '%' ) > 0 || this.settings.height.toString().indexOf( '%' ) > 0 ) {

                svgWidth = Math.round( this.element.offsetWidth / 100 * parseInt( this.settings.width ) );
                svgHeight = Math.round( svgWidth / 100 * parseInt( this.settings.height ) );

            } else {

                svgWidth = parseInt( this.settings.width );
                svgHeight = parseInt( this.settings.height );

            }

            if ( windowWidth <= svgWidth )
                svgWidth = windowWidth;

            if ( windowHeight <= svgHeight )
                svgHeight = windowHeight;

            //---

            this.center2D = { x: svgWidth / 2, y: svgHeight / 2 };

            this.speed.x = this.settings.speed / this.center2D.x;
            this.speed.y = this.settings.speed / this.center2D.y;

            if ( svgWidth >= svgHeight )
                this.diameter = svgHeight / 100 * parseInt( this.settings.radius );
            else
                this.diameter = svgWidth / 100 * parseInt( this.settings.radius );

            if ( this.diameter < 1 )
                this.diameter = 1;

            this.radius = this.diameter / 2;

            if ( this.radius < this.settings.radiusMin ) {

                this.radius = this.settings.radiusMin;
                this.diameter = this.radius * 2;

            }

            //---

            this.svg.setAttribute( 'width', svgWidth );
            this.svg.setAttribute( 'height', svgHeight );

            if ( this.settings.bgDraw ) {

                this.bg.setAttribute( 'width', svgWidth );
                this.bg.setAttribute( 'height', svgHeight );

            }

            //---

            this.setEntryPositions( this.radius );

        };



        //---

     setEntryPositions( radius ) {

            for ( var i = 0, l = this.entryHolder.length; i < l; i++ ) {

                this.setEntryPosition( this.entryHolder[ i ], this.radius );

            }

        };

     setEntryPosition( entry, radius ) {

            var dx = entry.vectorPosition.x - this.center3D.x;
            var dy = entry.vectorPosition.y - this.center3D.y;
            var dz = entry.vectorPosition.z - this.center3D.z;

            var length = Math.sqrt( dx * dx + dy * dy + dz * dz );

            entry.vectorPosition.x /= length;
            entry.vectorPosition.y /= length;
            entry.vectorPosition.z /= length;

            entry.vectorPosition.x *= radius;
            entry.vectorPosition.y *= radius;
            entry.vectorPosition.z *= radius;

        };

     addEntry( index, entryObj, x, y, z ) {
            
            var entry = {};

                if ( typeof entryObj.label != 'undefined' ) {

                    entry.element = document.createElementNS( this.svgNS, 'text' );
                    entry.element.setAttribute( 'x', 0 );
                    entry.element.setAttribute( 'y', 0 );
                    entry.element.setAttribute( 'fill', this.settings.fontColor );
                    entry.element.setAttribute( 'font-family', this.settings.fontFamily );
                    entry.element.setAttribute( 'font-size', this.settings.fontSize );
                    entry.element.setAttribute( 'font-weight', this.settings.fontWeight );
                    entry.element.setAttribute( 'font-style', this.settings.fontStyle );
                    entry.element.setAttribute( 'font-stretch', this.settings.fontStretch );
                    entry.element.setAttribute( 'text-anchor', 'middle' );
                    entry.element.textContent = this.settings.fontToUpperCase ? entryObj.label.toUpperCase() : entryObj.label;

                } else if ( typeof entryObj.image != 'undefined' ) {

                    entry.element = document.createElementNS( this.svgNS, 'image' );
                    entry.element.setAttribute( 'x', 0 );
                    entry.element.setAttribute( 'y', 0 );
                    entry.element.setAttribute( 'width', entryObj.width );
                    entry.element.setAttribute( 'height', entryObj.height );
                    entry.element.setAttribute( 'id', 'image_' + index );
                    entry.element.setAttributeNS( 'http://www.w3.org/1999/xlink','href', entryObj.image );

                    entry.diffX = entryObj.width / 2;
                    entry.diffY = entryObj.height / 2;
                    
                }

                entry.link = document.createElementNS( this.svgNS, 'a' );
                entry.link.setAttributeNS( 'http://www.w3.org/1999/xlink', 'xlink:href', entryObj.url );
                entry.link.setAttribute( 'target', entryObj.target );
                //entry.link.addEventListener( 'mouseover', mouseOverHandler, true );
                entry.link.addEventListener( 'mouseout', ( event ) => {

                    this.mouseReact = true;
                    var entry = this.getEntryByElement( event.target );

                    if ( entry.tooltip ) {

                        this.hideTooltip( entry );

                    }

                });

                entry.link.appendChild( entry.element );

                if ( typeof entryObj.tooltip != 'undefined' ) {

                    entry.tooltip = true;
                    entry.tooltipLabel = this.settings.tooltipFontToUpperCase ? entryObj.tooltip.toUpperCase() : entryObj.tooltip;;

                } else {

                    entry.tooltip = false;

                }

                entry.index = index;
                entry.mouseOver = false;

                entry.vectorPosition = { x:x, y:y, z:z };
                entry.vector2D = { x:0, y:0 };

            this.svg.appendChild( entry.link );
                
            return entry;
        
        };



         addEntries() {

            var tooltip = false;

            for ( var i = 1, l = this.settings.entries.length + 1; i < l; i++ ) {

                var phi = Math.acos( -1 + ( 2 * i ) / l );
                var theta = Math.sqrt( l * Math.PI ) * phi;

                var x = Math.cos( theta ) * Math.sin( phi );
                var y = Math.sin( theta ) * Math.sin( phi );
                var z = Math.cos( phi );

                var entry = this.addEntry( i - 1, this.settings.entries[ i - 1 ], x, y, z );
                
                this.entryHolder.push( entry );

                if ( typeof this.settings.entries[ i - 1 ].tooltip != 'undefined' ) {

                    tooltip = true;

                }
            
            }

            if ( tooltip ) {

                this.addTooltip();

            }
        
        };

         addTooltip() {

            this.tooltip = document.createElementNS( this.svgNS, 'text' );
            this.tooltip.setAttribute( 'x', 0 );
            this.tooltip.setAttribute( 'y', 0 );
            this.tooltip.setAttribute( 'fill', this.settings.tooltipFontColor );
            this.tooltip.setAttribute( 'font-family', this.settings.tooltipFontFamily );
            this.tooltip.setAttribute( 'font-size', this.settings.tooltipFontSize );
            this.tooltip.setAttribute( 'font-weight', this.ettings.tooltipFontWeight );
            this.tooltip.setAttribute( 'font-style', this.settings.tooltipFontStyle );
            this.tooltip.setAttribute( 'font-stretch', this.settings.tooltipFontStretch );
            this.tooltip.setAttribute( 'text-anchor', this.settings.tooltipTextAnchor );
            this.tooltip.textContent = '';

            this.svg.appendChild( this.tooltip );

        };

         getEntryByElement( element ) {

            for ( var i = 0, l = this.entryHolder.length; i < l; i++ ) {

                var entry = this.entryHolder[ i ];

                if ( entry.element.getAttribute( 'x' ) === element.getAttribute( 'x' ) && 
                     entry.element.getAttribute( 'y' ) === element.getAttribute( 'y' ) ) {

                    return entry;

                }

            }

            return;

        };

         highlightEntry( entry ) {

            for ( var i = 0, l = this.entryHolder.length; i < l; i++ ) {

                var e = this.entryHolder[ i ];

                if ( e.index === entry.index ) {

                    e.mouseOver = true; 

                } else {

                    e.mouseOver = false; 

                }

            } 

        };

        //---

         showTooltip( entry ) {

            if ( entry.tooltip ) {

                this.tooltip.setAttribute( 'x', entry.vector2D.x - this.settings.tooltipDiffX );
                this.tooltip.setAttribute( 'y', entry.vector2D.y - this.settings.tooltipDiffY );

                this.tooltip.textContent = this.settings.tooltipFontToUpperCase ? entry.tooltipLabel.toUpperCase() : entry.tooltipLabel;

                this.tooltip.setAttribute( 'opacity', 1.0 );

            }

        };

         hideTooltip( entry ) {

            this.tooltip.setAttribute( 'opacity', 0.0 );

        };

        //---
            
         render() {
            console.log("hereeeee");
            var fx = this.speed.x * this.mousePos.x - this.settings.speed;
            var fy = this.settings.speed - this.speed.y * this.mousePos.y;
            
            var angleX = fx * this.MATHPI180;
            var angleY = fy * this.MATHPI180;

            this.position.sx = Math.sin( angleX );
            this.position.cx = Math.cos( angleX );
            this.position.sy = Math.sin( angleY );
            this.position.cy = Math.cos( angleY );

            //---

            for ( var i = 0, l = this.entryHolder.length; i < l; i++ ) {
    
                var entry = this.entryHolder[ i ];

                //---

                if ( this.mouseReact ) {

                    var rx = entry.vectorPosition.x;
                    var rz = entry.vectorPosition.y * this.position.sy + entry.vectorPosition.z * this.position.cy;

                    entry.vectorPosition.x = rx * this.position.cx + rz * this.position.sx;
                    entry.vectorPosition.y = entry.vectorPosition.y * this.position.cy + entry.vectorPosition.z * -this.position.sy;
                    entry.vectorPosition.z = rx * -this.position.sx + rz * this.position.cx;

                }

                //---

                var scale = this.settings.fov / ( this.settings.fov + entry.vectorPosition.z );

                entry.vector2D.x = entry.vectorPosition.x * scale + this.center2D.x; 
                entry.vector2D.y = entry.vectorPosition.y * scale + this.center2D.y;
                
                //---

                if ( entry.diffX && entry.diffY ) {

                    entry.vector2D.x -= entry.diffX;
                    entry.vector2D.y -= entry.diffY;

                }

                //---

                entry.element.setAttribute( 'x', entry.vector2D.x );
                entry.element.setAttribute( 'y', entry.vector2D.y );

                //---

                var opacity;

                if ( this.mouseReact ) {

                    opacity = ( this.radius - entry.vectorPosition.z ) / this.diameter;

                    if ( opacity < this.settings.opacityOut ) {

                        opacity = this.settings.opacityOut;

                    }

                } else {

                    opacity = parseFloat( entry.element.getAttribute( 'opacity' ) );

                    if ( entry.mouseOver ) {

                        opacity += ( this.settings.opacityOver - opacity ) / this.settings.opacitySpeed;

                    } else {

                        opacity += ( this.settings.opacityOut - opacity ) / this.settings.opacitySpeed;

                    }

                }

                entry.element.setAttribute( 'opacity', opacity );
                
            }

            //---

            this.entryHolder = this.entryHolder.sort( function( a, b ) {

                return ( b.vectorPosition.z - a.vectorPosition.z );

            } );

        };

        //---

        requestAnimFrame() {

            return  window.requestAnimationFrame       ||
                    window.webkitRequestAnimationFrame ||
                    window.mozRequestAnimationFrame    ||
                    function( callback ) {
                        window.setTimeout( callback, 1000 / 60 );
                    };
                }

         animloop() {

            this.requestAnimFrame( this.animloop );

            this.render();

        };

        //---

        mouseOverHandler( event ) {

            this.mouseReact = false;

            //---

            var entry = this.getEntryByElement( event.target );

            this.highlightEntry( entry );

            if ( entry.tooltip ) {

                this.showTooltip( entry );

            }

        };

        mouseOutHandler( event ) {

            this.mouseReact = true;

            //---

            var entry = this.getEntryByElement( event.target );

            if ( entry.tooltip ) {

                this.hideTooltip( entry );

            }

        };

        //---

        

        getMousePos( svg, event ) {

            var rect = svg.getBoundingClientRect();

            return { 

                x: event.clientX - rect.left, 
                y: event.clientY - rect.top 

            };

        };

        //---

        resizeHandler( event ) {

            this.reInit();

        };

    ///window.SVG3DTagCloud = SVG3DTagCloud;

}

export default SVG3DTagCloud;


// WEBPACK FOOTER //
// ./src/SVG3DTagCloud.js